import { h, Component, Fragment } from 'preact';
import GoogleMapReact from 'google-map-react';
import Marker from '../components/Marker';

/** @jsx h */

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: 52.132633,
        lng: 5.291266,
      },
      zoom: 8,
      isLargeScreen: window.innerWidth > 1000, // Check initial screen size
    };
  }

  componentDidMount() {
    // Add resize event listener to update state on screen size change
    window.addEventListener('resize', this.handleResize.bind(this));
    this.setState({
      center: {
        lat: 52.132633,
        lng: 5.291266,
      },
      zoom: 8,
    });
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.setState({
      isLargeScreen: window.innerWidth > 1000,
    });
  }

  handleClick(lat, lng) {
    this.setState({
      center: {
        lat: Number(lat),
        lng: Number(lng),
      },
      zoom: this.state.zoom < 10 ? 10 : this.state.zoom,
    });
  }

  handleChange({ center, zoom }) {
    this.setState({
      center: center,
      zoom: zoom,
    });
  }

  // Dynamic map options based on screen size
  createMapOptions() {
    return {
      gestureHandling: this.state.isLargeScreen ? 'greedy' : 'greedy',
    };
  }

  render() {
    const { center, zoom } = this.state;

    return (
      <div class="c-housing-app__map">
        <GoogleMapReact
            // Local:
          // bootstrapURLKeys={{ key: 'AIzaSyDuB3_0l6klK-NORdYTo3193VKROdR4cvk' }}
          // LIVE: 
          bootstrapURLKeys={{ key: 'AIzaSyBXwapq2IH0jnnMBdV3cAUFAyqFOM0JAxU' }}
          center={center}
          zoom={zoom}
          options={this.createMapOptions.bind(this)} // Pass dynamic options
          onChange={this.handleChange.bind(this)}
        >
          {this.props.posts.map(post => {
            if (post.meta.latitude !== '' && post.meta.longitude !== '') {
              return (
                <Marker
                  lat={post.meta.latitude}
                  lng={post.meta.longitude}
                  activeHover={post.activeHover}
                  zoom={this.state.zoom}
                  post={post}
                  handleClick={this.handleClick.bind(this)}
                />
              );
            } else {
              return null;
            }
          })}
        </GoogleMapReact>
      </div>
    );
  }
}

export default Map;


// WEBPACK FOOTER //
// ./src/js/housing/containers/Map.js